import { createContext } from "react";
import { State } from "../types";

export type LockState =
  | { status: "free" }
  | { status: "mine" }
  | { status: "other"; ownerName: string };

export const defaultLockState: LockState = { status: "free" };

type LockStateType = State<LockState>;

export const LockContext = createContext<LockStateType>([
  defaultLockState,
  () => {},
]);
